<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full-middle"
      no-padding
      :confirm-loading="confirmLoading"
      :contentStyle="contentStyle"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>打印箱唛</span>
    </template>
    <template #content>
      <gj-alert show-icon>
        <template #title>
          如果您的纸张类型一致、打印数量与实际装箱数量一致，可以尝试快速填表功能。
        </template>
      </gj-alert>
      <el-form
          ref="form"
          :model="form"
          :inline="true"
          label-width="90px"
          >
        <div class="print-tip">快速填表：</div>
        <el-form-item
            label="纸张类型"
            prop="paperType">
          <gj-select
              v-model="form.paperType"
              @input="paperTypeInput"
              :options="paperLabelOption"
              width="350px"
          ></gj-select>
        </el-form-item>
        <el-form-item style="margin-left: 8px;">
          <gj-checkbox
              v-model="form.autoPrintNum"
              @input="autoPrintNumInput"
          >打印数量等于箱子数</gj-checkbox>
        </el-form-item>
        <gj-table
            :index="false"
            name="printProductLabel"
            :data="form.items"
            :columns="columns"
            :offset-height="74">
          <template v-slot:header:paperType>
            <div class="paper-type"><span class="required-icon">*</span>纸张类型</div>
          </template>
          <template v-slot:paperType="{ index }">
            <el-form-item
                :prop="`items.${index}.paperType`"
                :rules="[
                  { required: true, message: '请纸张类型', trigger: ['blur', 'change'] }
                ]"
                class="gj-table-item paper-type">
              <gj-select
                  v-model="form.items[index].paperType"
                  :options="paperLabelOption"
                  :clearable="false"
                  width="350px"
              ></gj-select>
            </el-form-item>
          </template>
          <template v-slot:printNum="{ index }">
            <el-form-item
                :prop="`items.${index}.printNum`"
                :rules="[
                  { required: true, message: '请输入打印数量', trigger: ['blur', 'change'] },
                  $gjReRule(RE.pt, '请输入大于0的整数')
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[index].printNum"
                  width="120px">
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:op="{ index }">
            <gj-button type="text" @click="deleteItem(index)">删除</gj-button>
          </template>
        </gj-table>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>

  import {formRuleMixin, formValidatorMixin, modalMixIn} from "../../../../../minxins";
  import {isMeaningful} from "@/utils/common";
  import {getPageTypes, printShipmentBoxMark} from "@/api/logistics";

  export default {
    name: "app-print-box-mark-modal",
    mixins: [modalMixIn, formValidatorMixin, formRuleMixin],
    props: {
      shipments: {
        type: Array
      }
    },
    created() {
      this.form.items = this.shipments.map(item => ({
        ...item,
        paperType: null,
        printNum: null
      }));
      getPageTypes()
        .then((data) => {
          this.paperLabelOption = data;
        })
    },
    data() {
      return {
        paperLabelOption: [],
        form: {
          paperType: null,
          autoPrintNum: false,
          items: []
        },
        columns: [
          {id: 'sku', header: 'ShipmentID', field: 'shipmentId', width: '150px'},
          {id: 'numberOfPackages', header: '箱子数', field: 'numberOfPackages', width: '70px', align: 'right'},
          {id: 'paperType', header: 'slot:paperType', field: 'slot:paperType', minWidth: '100px'},
          {id: 'printNum', header: '打印数量', field: 'slot:printNum', width: '180px', required: true},
        ],
        contentStyle: {
          'height': '100%',
          'box-sizing': 'border-box',
          'padding': '16px 20px 0 20px'
        }
      }
    },
    methods: {
      paperTypeInput(id) {
        if (isMeaningful(id)) {
          this.form.items.forEach(e => e.paperType = id);
        }
      },
      autoPrintNumInput(check) {
        if (check) {
          this.form.items.forEach(e => e.printNum = e.numberOfPackages);
        }
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
      },
      confirm() {
        if (this.form.items.length === 0) {
          this.$gjMessage.error('请选择要打印的货件');
          return;
        }
        if (this.formValidate()) {
          this.confirmLoading = true;
          printShipmentBoxMark(this.form.items.map(item => ({
            id: item.id,
            pageType: item.paperType,
            printQuantity: item.printNum,
          })))
            .then((data) => {
              (data || []).forEach(url => {
                window.open(url);
              });
              this.$gjDestroy();
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-alert--info{
    margin-bottom: 15px;
  }
  .print-tip {
    display: inline-block;
    margin-top: 7px;
    font-size: 14px;
  }
  .paper-type {
    padding-left: 100px;
  }
  .required-icon {
    margin-right: 2px;
    color: red;
  }
  /deep/ .el-dialog__body{
    padding: 0;

  }
  /deep/ .gj-table--default td.vxe-body--column{
    height: 56px !important;
  }
</style>

